import 'antd/dist/antd.min.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import React from 'react';
import ReactDOM from 'react-dom';
import BasicRoute from "./common/route/basic.route";
import './index.css';

ReactDOM.render(
    <BasicRoute />,
  document.getElementById('root')
);
